import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { MTOComponentTieredPricingContainerModel } from '../../../../../../models/aggregates/erp/mto/mto-component-tiered-pricing-container.model';





@Injectable({
  providedIn: 'root'
})
export class MTOComponentTieredPricingService extends BaseApiTemplateService<MTOComponentTieredPricingContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
  Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'component-tiered-pricings/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'components';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'component-tiered-pricings/backoffice-ep';
    this.httpClient = http;
  }
}

